import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
  {
    path: 'pages',
    loadChildren: () =>
      import('./modules/modules.module').then(m => m.ModulesModule),
    canActivate: [MsalGuard],
    title: 'Mata Energy',
  },
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: '**', redirectTo: 'pages' },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
